import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "lat", "lng", "submitBtn" ]

  requestLocation(event) {
    if (event) event.preventDefault();

    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser");
      return;
    }

    const btn = this.submitBtnTarget;
    const originalHTML = btn.innerHTML;
    btn.innerHTML = "Locating...";
    btn.disabled = true;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.latTarget.value = position.coords.latitude;
        this.lngTarget.value = position.coords.longitude;
        
        btn.innerHTML = originalHTML;
        btn.disabled = false;
        
        // Auto-submit the form
        this.element.requestSubmit();
      },
      (error) => {
        console.error("Error getting location", error);
        let errorMsg = "Unable to retrieve your location.";
        if (error.code === error.PERMISSION_DENIED) {
          errorMsg = "Location access was denied. Please enable it in your browser settings.";
        }
        alert(errorMsg);
        
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      },
      { timeout: 10000, maximumAge: 60000 }
    );
  }
}
